import { listPayoutMethods, createRegistrationLink, deletePayoutMethod } from '@motionelements/core/src/api/payout-methods.js';
import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';

const state = {
  methods: null,
  payoneerRegistrationLink: null,
  //
  payoutForm: {
    method: '',
    account: '',
    threshold: 0,
  },
  //
  loading: false,
};

const getters = {
  getPayoneerMethods(state) {
    return state.methods ? state.methods.filter(method => method.type === 'payoneer') : null;
  },
  getPaypalMethods(state) {
    return state.methods ? state.methods.filter(method => method.type === 'paypal') : null;
  },
};

const actions = {
  LIST_PAYOUT_METHODS({ commit }, type) {
    commit('setLoading', true);
    return listPayoutMethods({ type })
      .then((response) => {
        // response.data.data = [];
        commit('setPayoutMethods', response.data.data);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  CREATE_PAYONEER_REGISTRATION_LINK({ commit }, redirectUrl) {
    return createRegistrationLink({
      type: 'payoneer',
      redirect_url: redirectUrl,
    })
      .then((response) => {
        const url = _.get(response.data.data, 'registration.url');
        if (url) commit('setPayoneerRegistrationLink', url);
      })
      .catch(err => {
        console.dir(err);
      });
  },
  // eslint-disable-next-line
  DELETE_PAYOUT_METHOD({ commit, dispatch }, payoutMethodId) {
    return deletePayoutMethod(payoutMethodId);
  },
};

const mutations = {
  setPayoutMethods(state, methods) {
    state.methods = methods;
  },
  setPayoneerRegistrationLink(state, link) {
    state.payoneerRegistrationLink = link;
  },
  removeMethod(state, id) {
    const index = state.methods.findIndex(method => method.id === id);
    console.log(index);
    if (index > -1) state.methods.splice(index, 1);
  },
  setPayoutFormThreshold(state, amount) {
    state.payoutForm.threshold = amount;
  },
  setPayoutForm(state, { method = '', account = '', threshold = 0 }) {
    state.payoutForm.method = method;
    state.payoutForm.account = account;
    state.payoutForm.threshold = threshold;
  },
  resetPayoutForm(state) {
    state.payoutForm.method = '';
    state.payoutForm.account = '';
    state.payoutForm.threshold = 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: { ...mutations, ...loadingMutation },
};
